import { checksession } from "../../lib/checksession.js";
import { refreshtoken } from "../../lib/refreshtoken.js";

export let setTockenInCoockie = (tocken) => {
  var expires = new Date();
  expires.setTime(expires.getTime() + 30 * 60 * 1000);
  document.cookie =
    "userToken" +
    "=" +
    tocken +
    "; expires=" +
    expires.toUTCString() +
    ";path=/";
};

export let setRefreshTockenInCoockie = (tocken) => {
  var expires = new Date();
  expires.setTime(expires.getTime() + 120 * 60 * 1000);
  document.cookie =
    "refreshToken" +
    "=" +
    tocken +
    "; expires=" +
    expires.toUTCString() +
    ";path=/";
};

export let getCookieTocken = (cname) => {
  var name = cname + "=";
  var decodedCookie =
    typeof window !== "undefined" ? decodeURIComponent(document.cookie) : "";
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

export let removeUserTokenFromCookie = () => {
  document.cookie =
    "userToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
};

//Not in use (checked)
function callRefreshTokenApi() {
  if (getCookieTocken("refreshToken")) {
    let refreshtokendata = {
      site_id: "6124e1368ede4f08bf2d9ad4",
      refreshToken: getCookieTocken("refreshToken"),
    };
    refreshtoken(refreshtokendata).then((res) => {
      console.log("res of refresh token in common", res);
      if (res.status === true) {
        setTockenInCoockie(res.accessToken);
        setRefreshTockenInCoockie(res.refreshToken);
        return true;
      } else {
        return false;
      }
    });
  } else {
    return false;
  }
}
//Not in use (checked)
export let authenticatedUser = () => {
  if (getCookieTocken("userToken")) {
    let checksessionData = {
      site_id: "6124e1368ede4f08bf2d9ad4",
      accessToken: getCookieTocken("userToken"),
    };
    checksession(checksessionData).then((res) => {
      console.log("res of check session in common", res);
      if (res.status === true) {
        return true;
      } else {
        callRefreshTokenApi();
      }
    });
  } else {
    callRefreshTokenApi();
  }
  // return true;
};
